import { Injectable, Inject, Injector } from '@angular/core';
import {environment, SENTRY_APP_KEY, SENTRY_PROJECT_KEY} from '../../../../environments/environment';
import * as Sentry from '@sentry/browser';
import {AlertController, Platform} from '@ionic/angular';
import {AuthenticationService} from '../../authentication.service';
import {ConfigService} from '../config/config.service';
import {CustomError} from './custom-error';
import {TranslateService} from '@ngx-translate/core';
import { EnvService } from '../config/env.service';

@Injectable({
    providedIn: 'root'
})
export class ErrorService {

    constructor(
        private plt: Platform,
        private authenticationService: AuthenticationService,
        private envService: EnvService,
        private alertController: AlertController,
        private translate: TranslateService,
    ) {
        this.plt.ready().then(() => {
            this.init();
        });
    }

    init() {
        try {
            Sentry.init({
              dsn: `https://${SENTRY_APP_KEY}@01.mychronos.app/${SENTRY_PROJECT_KEY}`,
            });
        } catch (e) {
            console.error('Error on Sentry init');
        }
        // this.authenticationService.authenticationState.subscribe(state => {
        //     if (state != null && state === true) {
        //         this.authenticationService.getUser().then( (user: User) => {
        //             if (user !== null) {
        //                 this.setUser(user);
        //             }
        //         });
        //     }
        // });
        this.envService.getDeviceInfo().then( deviceInfo => {
            this.setDeviceInfo(deviceInfo);
        });
    }

    // setUser(user: User) {
    //     Sentry.setUser({
    //         id: user.id.toString(),
    //         email: user.email,
    //     });
    // }

    setDeviceInfo(info: any) {
        Sentry.setExtras(info);
    }

    async log(error: Error) {
        if (environment.production === true) {
            console.error(error);
        }
    }

    public captureException(exception: any) {
        return Sentry.captureException(exception);
    }

    showCustomErrorAlert(error: CustomError){
        let errorMessage = this.translate.instant('ERRORS.GENERIC');
        try{
            const err = JSON.parse(error.message);
            if (error.statusCode === 422) {
                errorMessage = err.error.message;
            }else if (error.statusCode === 405) {
                errorMessage = this.translate.instant('ERRORS.WITHOUT_PERMISSION');
            }
        }catch (e) {}
        this.showOkAlert(errorMessage);
    }

    async showOkAlert(headerText: string) {
        const alert = await this.alertController.create({
            header: headerText,
            buttons: [this.translate.instant('DEFAULTS.OK')],
        });

        await alert.present();
    }

    async showWarningAlert(message: string) {
        const alert = await this.alertController.create({
            header: this.translate.instant('DEFAULTS.WARNING'),
            message,
            buttons: [this.translate.instant('DEFAULTS.OK')],
        });

        await alert.present();
    }
}
